import { noop } from 'lodash';
import { put } from 'redux-saga/effects';

import { takeRequest } from 'services/sagas/takeRequest';
import { createUIErrorMessage } from 'modules/errors';
import { authApi } from 'config/antonio';
import config from 'config';

import { fetchClosedIncidentsTypes, fetchClosedIncidents as actions } from '../actions';

type AxiosData = { [key: string]: any }[];

function* fetchClosedIncidents(action) {
    const { id } = action.meta;
    try {
        const { data } = yield* authApi.get<AxiosData>(config.api.closedIncidents, {
            uriParams: { id },
        });
        yield put(actions.fetchClosedIncidentsSuccess(id, data));
    } catch (error) {
        const uiError = createUIErrorMessage(error);
        yield put(actions.fetchClosedIncidentsFailure(id, uiError));
    }
}

export default function* () {
    yield takeRequest(
        {
            requestIdSelector: () => 'fetchClosedIncidents',
            leading: true,
        },
        {
            pattern: fetchClosedIncidentsTypes.FETCH_CLOSED_INCIDENTS_REQUEST,
            handler: fetchClosedIncidents,
        },
        {
            pattern: fetchClosedIncidentsTypes.FETCH_CLOSED_INCIDENTS_CANCEL,
            handler: noop,
        },
    );
}
